import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { partnerPortalAPI } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';

const STAGES = ['Indicado', 'Em análise', 'Chamado', 'Entrevista', 'Contratado', 'Não contratado'];
const COLORS = {
  Indicado: 'bg-slate-100 text-slate-700', 'Em análise': 'bg-blue-100 text-blue-700', Chamado: 'bg-cyan-100 text-cyan-800',
  Entrevista: 'bg-violet-100 text-violet-700', Contratado: 'bg-green-100 text-green-700', 'Não contratado': 'bg-red-100 text-red-700',
};

export const PartnerReferralsTab = () => {
  const [rows, setRows] = useState(null);
  const [filter, setFilter] = useState(null);

  useEffect(() => {
    partnerPortalAPI.referrals().then((r) => setRows(r.data)).catch(() => toast.error('Erro ao carregar indicações'));
  }, []);

  const shown = (rows || []).filter((r) => !filter || r.etapa === filter);
  return (
    <Card data-testid="partner-referrals-tab">
      <CardHeader>
        <CardTitle>Acompanhamento das Indicações</CardTitle>
        <CardDescription>Indicado → Em análise → Chamado → Entrevista → Contratado / Não contratado</CardDescription>
        <div className="flex flex-wrap gap-2 pt-2">
          {STAGES.map((s) => {
            const n = (rows || []).filter((r) => r.etapa === s).length;
            return (
              <button key={s} type="button" onClick={() => setFilter(filter === s ? null : s)}
                className={`text-xs px-3 py-1 rounded-full ${COLORS[s]} ${filter === s ? 'ring-2 ring-amber-500' : ''}`} data-testid={`referral-stage-${s}`}>
                {s}: {n}
              </button>
            );
          })}
        </div>
      </CardHeader>
      <CardContent>
        {!rows ? <Loader2 className="w-6 h-6 animate-spin text-amber-500 mx-auto" /> : shown.length === 0 ? (
          <p className="text-sm text-slate-500 py-6 text-center" data-testid="partner-referrals-empty">Nenhuma indicação {filter ? 'nesta etapa' : 'ainda'}.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="partner-referrals-table">
              <thead><tr className="text-left text-slate-500 border-b"><th className="py-2 pr-3">Candidato</th><th className="pr-3">Vaga</th><th className="pr-3">Empresa</th><th className="pr-3">Indicado em</th><th>Etapa</th></tr></thead>
              <tbody>
                {shown.map((r) => (
                  <tr key={r.id} className="border-b last:border-0" data-testid={`referral-row-${r.id}`}>
                    <td className="py-2 pr-3 font-medium">{r.candidato}</td>
                    <td className="pr-3">{r.vaga}</td>
                    <td className="pr-3">{r.empresa}</td>
                    <td className="pr-3 whitespace-nowrap">{new Date(r.indicado_em).toLocaleDateString('pt-BR')}</td>
                    <td><span className={`text-xs px-2 py-0.5 rounded-full ${COLORS[r.etapa]}`}>{r.etapa}</span>{r.detalhe && <span className="block text-[11px] text-slate-500">{r.detalhe}</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
